import { DiscoveryAction, DiscoveryContextState, DiscoveryPhase } from './types';

export const initialDiscoveryState: DiscoveryContextState = {
    autoPromptEligible: false,
    discovered: null,
    error: null,
    installationID: null,
    instanceId: null,
    isNewDevice: false,
    phase: DiscoveryPhase.Idle,
    progress: 0,
    stepSubtitle: '',
    stepTitle: '',
    submitting: false,
};

export function discoveryReducer(state: DiscoveryContextState, action: DiscoveryAction): DiscoveryContextState {
    switch (action.type) {
        case 'INIT':
            return {
                ...initialDiscoveryState,
                autoPromptEligible: action.payload.autoPromptEligible,
                installationID: action.payload.installationID,
                isNewDevice: action.payload.isNewDevice,
                phase: action.payload.autoPromptEligible ? DiscoveryPhase.Prompt : DiscoveryPhase.Idle,
            };
        case 'SHOW_PROMPT':
            return { ...state, phase: DiscoveryPhase.Prompt };
        case 'START_SCAN':
            return {
                ...state,
                discovered: null,
                error: null,
                instanceId: action.payload.instanceId,
                phase: DiscoveryPhase.Scanning,
                progress: 0,
            };
        case 'SCAN_PROGRESS':
            return {
                ...state,
                progress: action.payload.progress,
                stepSubtitle: action.payload.stepSubtitle ?? '',
                stepTitle: action.payload.stepTitle ?? '',
            };
        case 'SCAN_RESULT':
            return {
                ...state,
                discovered: {
                    devicespecId: action.payload.devicespecId,
                    groupId: action.payload.groupId,
                    raw: action.payload.raw,
                },
                phase: DiscoveryPhase.Found,
                progress: 100,
            };
        case 'SCAN_ERROR':
            return { ...state, error: action.payload.error, phase: DiscoveryPhase.Error };
        case 'CANCEL':
            return {
                ...state,
                discovered: null,
                error: null,
                phase: DiscoveryPhase.Cancelled,
                progress: 0,
                stepSubtitle: '',
                stepTitle: '',
            };
        case 'SUBMIT_START':
            return { ...state, submitting: true };
        case 'SUBMIT_SUCCESS':
            return { ...state, phase: DiscoveryPhase.Completed, submitting: false };
        case 'RESET':
            return initialDiscoveryState;
        default:
            return state;
    }
}
